import React, { useState, useCallback, useEffect } from "react";
import { getBalance, getHistory, credit, syncBalance, buildUPIUri, makeTxnRef, UPI_VPA } from "../services/WalletService";
import { useNavigate } from "react-router-dom";
import Seo from "../Components/Seo";

const QUICK_AMOUNTS = [10, 20, 30, 50, 100];

export default function WalletScreen() {
  const navigate = useNavigate();
  const [balance, setBalance] = useState(() => getBalance());
  const [history, setHistory] = useState(() => getHistory());
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("Wallet Top-up");
  const [msg, setMsg] = useState("");

  const refresh = useCallback(() => {
    setBalance(getBalance());
    setHistory(getHistory());
  }, []);

  // Server se balance sync (source of truth)
  useEffect(() => {
    const mobile = localStorage.getItem("userMobileNumber");
    if (!mobile) return;
    syncBalance(mobile).then(() => refresh());
    const onUpdate = () => refresh();
    window.addEventListener("wallet:updated", onUpdate);
    return () => window.removeEventListener("wallet:updated", onUpdate);
  }, [refresh]);

  const handleCredit = () => {
    const amt = parseFloat(amount);
    if (!amt || amt <= 0) {
      setMsg("Sahi amount daalein.");
      return;
    }
    const txnRef = makeTxnRef(localStorage.getItem("userMobileNumber"));
    const uri = buildUPIUri({ amount: amt, note, txnRef });
    setMsg("Payment app (GPay/PhonePe/Paytm) open ho raha hai… Payment ke baad 'Balance +Add' se wallet top-up kar lein.");
    window.location.href = uri;
  };

  const handleTopUp = async () => {
    const amt = parseFloat(amount);
    if (!amt || amt <= 0) {
      setMsg("Sahi amount daalein.");
      return;
    }
    const result = await credit(amt, note || "Wallet Top-up");
    setAmount("");
    refresh();
    if (result?.success) {
      setMsg(`₹${amt} wallet me add ho gaya.`);
    } else {
      setMsg("Wallet add nahi hua — internet check karke dobara try karein.");
    }
  };

  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "24px" }}>
      <Seo title="Wallet & UPI Add Money" description="AIO India wallet — UPI se paise add karein, balance dekhein aur transactions ka history check karein." path="/wallet" />
      <h2 style={{ fontSize: "24px", fontWeight: 800, color: "#0f172a", marginBottom: "8px" }}>My Wallet</h2>

      <div
        style={{
          background: "linear-gradient(135deg, #7c3aed, #f59e0b)",
          borderRadius: "16px",
          padding: "24px",
          color: "#fff",
          marginBottom: "20px",
          boxShadow: "0 8px 24px rgba(124,58,237,0.35)",
        }}
      >
        <div style={{ fontSize: "13px", opacity: 0.9 }}>Available Balance</div>
        <div style={{ fontSize: "40px", fontWeight: 900, marginTop: "4px" }}>₹{balance}</div>
      </div>

      <div style={{ background: "#fff", borderRadius: "14px", padding: "20px", border: "1px solid #f1f5f9", marginBottom: "20px" }}>
        <div style={{ fontWeight: 800, color: "#0f172a", marginBottom: "10px" }}>Add Money (UPI)</div>
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "10px" }}>
          {QUICK_AMOUNTS.map((a) => (
            <button
              key={a}
              type="button"
              onClick={() => setAmount(String(a))}
              style={{
                padding: "8px 14px", borderRadius: "8px", border: "1px solid #ddd",
                background: amount === String(a) ? "#f0fdf4" : "#fff",
                color: "#0f172a", fontWeight: 700, cursor: "pointer",
              }}
            >
              ₹{a}
            </button>
          ))}
        </div>
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "10px" }}>
          <input
            value={amount}
            onChange={(e) => setAmount(e.target.value.replace(/[^0-9]/g, "").slice(0, 6))}
            placeholder="Amount (₹)"
            inputMode="numeric"
            style={{
              padding: "12px", borderRadius: "10px", border: "1px solid #ddd",
              fontSize: "15px", width: "160px",
            }}
          />
          <input
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Note (optional)"
            style={{
              padding: "12px", borderRadius: "10px", border: "1px solid #ddd",
              fontSize: "15px", flex: "1", minWidth: "180px",
            }}
          />
        </div>
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={handleCredit}
            style={{
              padding: "12px 24px", borderRadius: "10px", border: "none",
              background: "linear-gradient(135deg, #7c3aed, #a855f7)", color: "#fff",
              fontWeight: 700, cursor: "pointer",
            }}
          >
            Pay via UPI
          </button>
          <button
            type="button"
            onClick={handleTopUp}
            style={{
              padding: "12px 24px", borderRadius: "10px", border: "1px solid #7c3aed",
              background: "#fff", color: "#7c3aed", fontWeight: 700, cursor: "pointer",
            }}
          >
            Balance + Add
          </button>
        </div>
        <div style={{ marginTop: "10px", fontSize: "12px", color: "#64748b" }}>
          UPI ID: <strong>{UPI_VPA}</strong> — paisa bhejte hi "Balance + Add" dabao.
        </div>
        {msg && <div style={{ marginTop: "10px", fontSize: "13px", color: "#2563eb", fontWeight: 600 }}>{msg}</div>}
      </div>

      <div style={{ background: "#fff", borderRadius: "14px", padding: "20px", border: "1px solid #f1f5f9" }}>
        <div style={{ fontWeight: 800, color: "#0f172a", marginBottom: "12px" }}>Transaction History</div>
        {history.length === 0 ? (
          <div style={{ color: "#64748b", fontSize: "14px" }}>Koi transaction nahi.</div>
        ) : (
          history.slice(0, 20).map((t) => (
            <div
              key={t.id}
              style={{
                display: "flex", justifyContent: "space-between", alignItems: "center",
                padding: "10px 0", borderBottom: "1px solid #f1f5f9",
              }}
            >
              <div>
                <div style={{ fontWeight: 600, fontSize: "14px", color: "#0f172a" }}>{t.note}</div>
                <div style={{ fontSize: "12px", color: "#64748b" }}>
                  {new Date(t.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                </div>
              </div>
              <div style={{ fontWeight: 800, fontSize: "15px", color: t.type === "credit" ? "#16a34a" : "#dc2626" }}>
                {t.type === "credit" ? "+" : "−"}₹{t.amount}
              </div>
            </div>
          ))
        )}
      </div>

      <div style={{ marginTop: "16px", textAlign: "center" }}>
        <button
          type="button"
          onClick={() => navigate(-1)}
          style={{ padding: "10px 24px", borderRadius: "8px", border: "1px solid #ddd", background: "#fff", color: "#0f172a", fontWeight: 700, cursor: "pointer" }}
        >
          Back
        </button>
      </div>
    </div>
  );
}